<div class="pb-1" *ngFor="let assetObj of assetInfoObject.metadata">
  <form class="asset-info-form" [formGroup]="arvalMetadataForm" *ngIf="editFlag && assetObj.editable">
    <div *ngIf="assetObj.formControlName === 'name'" class="dataset-entry">
      <span class="dataset-entry-label field-label w-2/5">{{ assetObj.fieldLabel }}</span>
      <mat-form-field appearance="outline" color="primary" class="dataset-entry-value w-3/5">
        <input type="text" placeholder="{{ assetObj.fieldLabel }}" matInput formControlName="name" />
        <mat-error *ngIf="arvalMetadataForm.controls['name'].errors?.['required']" i18n>Name is required</mat-error>
      </mat-form-field>
    </div>
    <div class="dataset-entry my-2" *ngIf="['description'].includes(assetObj.formControlName)">
      <span class="dataset-entry-label field-label w-2/5">{{ assetObj.fieldLabel }}</span>
      <sp-editor
        formControlName="description"
        [placeholder]="assetObj.fieldLabel"
        [maxLength]="5000"
        [taggingOptions]="taggingOptions"
        (usersList)="taggedUserList($event)"
        (descriptionText)="editorDescriptionText($event)"
        class="dataset-entry-value"
      ></sp-editor>
    </div>
    <div *ngIf="['status'].includes(assetObj.formControlName)" class="dataset-entry">
      <span class="dataset-entry-label field-label w-2/5">{{ assetObj.fieldLabel }}</span>
      <sp-mat-select-search
        class="dataset-entry-value w-3/5 inline-block"
        [formControlName]="assetObj.formControlName"
        [dataSource]="assetObj.options"
        [config]="{
          multiple: assetObj.multiple,
          enableSecondPartLabel: true,
          search: true,
          required: arvalMetadataForm.controls[assetObj.formControlName].errors?.['required'],
          titleCase: assetObj.formControlName === 'status',
          requiredText: assetObj.fieldLabel + ' ' + textIsRequired
        }"
        [attrDataTestId]="'asset-metadata_select_' + assetObj.formControlName"
      ></sp-mat-select-search>
    </div>
  </form>
  <ng-template [ngIf]="asset[assetObj.formControlName] || asset['customFields']?.[assetObj.formControlName]">
    <div *ngIf="!editFlag || !assetObj.editable">
      <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'name'">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div
          class="dataset-entry-value inline-block w-3/5 break-words"
          [ngClass]="{
            'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
          }"
        >
          <span class="mr-2">{{ asset[assetObj.formControlName] }}</span>
        </div>
      </div>
      <div class="dataset-entry flex row items-start" *ngIf="['description'].includes(assetObj.formControlName)">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div
          class="dataset-entry-value inline-block w-3/5 break-words"
          [ngClass]="{
            'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
          }"
        >
          <div class="ql-container ql-snow !min-h-[inherit] !bg-inherit !border-0">
            <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[assetObj.formControlName || '']"></div>
          </div>
        </div>
      </div>
      <div class="dataset-entry flex row items-start" *ngIf="['createdBy', 'updatedBy'].includes(assetObj.formControlName)">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div class="dataset-entry-value inline-block w-3/5">
          <span class="cursor-pointer hover:bg-[#e3e0e0] -m-1 px-1 py-1 rounded-lg" (click)="assetCommonService.onClick(assetObj.formControlName, asset)">
            {{ (valueListsService.lookupUserInfo(asset[assetObj.formControlName]) | async)?.name }}
          </span>
        </div>
      </div>
      <div class="dataset-entry flex row items-start" *ngIf="['createdAt', 'updatedAt'].includes(assetObj.formControlName)">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div class="dataset-entry-value inline-block w-3/5">
          <span *ngIf="asset[assetObj.formControlName]">{{ asset[assetObj.formControlName] | spDateFormat: { isSafe: true } }}</span>
        </div>
      </div>
      <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'status'">
        <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
        <div class="dataset-entry-value inline-block w-3/5">
          <span>{{ asset[assetObj.formControlName] | customTitleCase }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
